/* eslint-disable jsx-a11y/anchor-is-valid */
// components/PhotoCard.tsx
import React from 'react';
import { BiSolidDownload } from 'react-icons/bi';
import PdfThumbnail from './PdfThumbnail';

const AttachmentCard = ({
  index,
  attachmentAlt,
  attachmentUrl,
  attachmentType,
  dropdownMenuId,
  note,
  onImageError,
}) => {
  return (
    <div key={index} className="col-3 rounded border p-3">
      <a className="text-center image-component">
        {attachmentType === 'pdf' ? (
          <PdfThumbnail url={attachmentUrl} />
        ) : (
          <img
            src={attachmentUrl}
            style={{
              maxWidth: '220px',
              height: '220px',
              objectFit: 'cover',
            }}
            alt={attachmentAlt}
            onError={onImageError}
          />
        )}
      </a>

      <div className="d-flex mt-4">
        <div className="d-flex flex-column">
          <p className="fz-14 fw-bold mb-0">
            <span className="text-secondary">Note:</span> {note}
          </p>
        </div>

        <a
          href="#"
          className=""
          role="button"
          id={`${dropdownMenuId}-${index}`}
          data-bs-toggle="dropdown"
          aria-expanded="false"
          style={{ marginLeft: 'auto' }}
        >
          <BiSolidDownload />
        </a>
        <ul
          className="dropdown-menu"
          aria-labelledby={`${dropdownMenuId}-${index}`}
        >
          <li>
            <a className="dropdown-item fz-14" href={attachmentUrl} download>
              Download
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default AttachmentCard;
